<template>
    <div class="main">
        <a-row class="container" :gutter="8">
            <a-col :span="16">
                <a-form :form="form">
                    <a-form-item label="指令标题" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-input placeholder="请输入指令标题" size="large" v-decorator="['title',{rules: [{ required: true, message: '请输入指令标题' }]}]">
                            <a-icon slot="prefix" type="form" value="title"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item label="指令说明" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <vue-html5-editor :content="content" auto-height @change="updateData" ref="myeditor" ></vue-html5-editor>
                    </a-form-item>
                    <!--<a-form-item label="渠道" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">-->
                        <!--<a-radio-group name="radioGroup" v-model="myform.channel">-->
                            <!--<a-radio :value="item.id" v-for="(item, index) in channelList" :key="index">{{item.name}}</a-radio>-->
                        <!--</a-radio-group>-->
                    <!--</a-form-item>-->
                </a-form>
            </a-col>
        </a-row>
        <footer-tool-bar>
            <a-button type="danger" @click="deleteArticle" v-show="articleId">删除</a-button>
            <a-button type="primary" @click="handleSubmit">保存</a-button>
            <a-button type="primary" ghost @click="goBackToList">
                <a-icon type="left" />返回列表
            </a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import FooterToolBar from '../../components/FooterToolBar'
    export default {
        name: "AddReport",
        components:{
            FooterToolBar
        },
        beforeCreate () {
            this.form = this.$form.createForm(this);
        },
        data () {
            return {
                userInfo: '',
                content: '请输入内容',
                articleId: '',
                channelList: [],
                myform: {
                    channel: 1 // 1为宣传指令
                },
                isShowModal: true,
                form: this.$form.createForm(this),
            }
        },
        methods: {
            handleSubmit (e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                    } else {
                        return
                    }
                    if (this.content === '请输入内容' || !this.content) {
                        this.$message.error('请输入指令说明')
                        return
                    }
                    // if (!this.myform.channel) {
                    //     this.$message.error('请选择渠道')
                    //     return
                    // }
                    var postData = {id: this.articleId, 'title': values.title, 'content': this.content, 'channel_id': this.myform.channel, 'user_id': this.userInfo.userid, 'reporter': this.userInfo.truename}
                    this.$http.post('api/report/update', postData)
                        .then((res) => {
                            if (res.data.state === 200) {
                                // 发布成功 全部置空
                                this.form.resetFields()
                                this.content = '请输入内容'
                                this.myform.channel = ''
                                if (this.articleId) {
                                    this.$message.success('修改成功')
                                } else {
                                    this.$message.success('发布成功')
                                }
                                setTimeout(() => {
                                    this.$router.push('/Main/Direct/DirectList')
                                }, 2000)
                            }
                        })
                        .catch(() => {
                        })
                })
            },
            updateData (content) {
                this.content = content
            },
            deleteArticle () {
                const that = this
                this.$confirm({
                    title: '确定删除该指令?',
                    content: '',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    centered: true,
                    onOk() {
                        that.deleting()
                    },
                    onCancel() {
                    },
                });
            },
            deleting () {
                this.$http.post('api/report/delete', {ids: this.articleId})
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.$message.success('已删除')
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 2000)
                        }
                    })
                    .catch(() => {
                    })
            },
            // 获取报题渠道
            getChannel () {
                this.$http.post('api/report/channel')
                    .then((res) => {
                        this.isShowModal = false
                        if (res.data.state === 200) {
                            for (var i in res.data.data) {
                                if (res.data.data[i].name != '宣传指令') {
                                    this.channelList.push(res.data.data[i])
                                }
                            }
                            this.$store.commit('storeChanelList', this.channelList)
                        } else {
                        }
                    })
                    .catch(() => {
                        this.isShowModal = false
                    })
            },
            goBackToList () {
                this.$router.push('/Main/Direct/DirectList')
            }
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            // if (this.$store.state.channelList.length === 0) {
            //     this.getChannel()
            // } else {
            //     this.isShowModal = false
            //     this.channelList = this.$store.state.channelList
            // }

            // 获取文章详情
            if (this.$route.query.id) {
                this.articleId = this.$route.query.id
                this.$http.post('api/report/detail', {id: this.articleId})
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.form.setFieldsValue({title: res.data.data.title})
                            this.content = res.data.data.content
                            this.myform.channel = res.data.data.channel_id
                        }
                    })
                    .catch(() => {
                    })
            }
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 56px;
    }
    .mgt10{
        margin-top: 10px;
    }
</style>
